import { StoryblokMultilink } from '~/types/storyblok-generated';

export const mockServiceMenu = [
  {
    headline: 'Gestalten<br />& Bauen',
    nav: [
      {
        url: '/de-de/leistungen/projektentwicklung/',
        label: 'Projektentwicklung',
      },
      {
        url: '/de-de/leistungen/schluesselfertigbau/',
        label: 'Schlüsselfertigbau',
      },
      {
        url: '/de-de/leistungen/holzsystembau/',
        label: 'Holzsystembau',
      },
      {
        url: '/de-de/leistungen/hoch-und-tiefbau/',
        label: 'Hoch- & Tiefbau',
      },
      {
        url: '/de-de/leistungen/netzbau/',
        label: 'Netzbau',
      },
      {
        url: '/de-de/leistungen/energietechnik/',
        label: 'Energietechnik',
      },
    ],
  },
  {
    headline: 'Erhalten<br />& Sanieren',
    nav: [
      {
        url: '/de-de/leistungen/bauwerksanierung/',
        label: 'Bauwerksanierung',
      },
      {
        url: '/de-de/leistungen/absaugen-und-verfuellen/',
        label: 'Absaugen & Verfüllen',
      },
      {
        url: '/de-de/leistungen/kanalsanierung/',
        label: 'Kanalsanierung',
      },
    ],
  },
  {
    headline: 'Aufbereiten<br />& Recyceln',
    nav: [
      {
        url: '/de-de/leistungen/umweltsanierung/',
        label: 'Umweltsanierung',
      },
      {
        url: '/de-de/leistungen/abbruch/',
        label: 'Abbruch',
      },
      {
        url: '/de-de/leistungen/recycling/',
        label: 'Recycling',
      },
    ],
  },
  {
    headline: 'Gewinnen<br />& Entsorgen',
    nav: [
      {
        url: '/de-de/leistungen/baustoffe/',
        label: 'Baustoffe',
      },
      {
        url: '/de-de/leistungen/entsorgung/',
        label: 'Entsorgung',
      },
      {
        url: '/de-de/leistungen/mineralstoffbehandlung/',
        label: 'Mineralstoffbehandlung',
      },
      {
        url: '/de-de/leistungen/logistik/',
        label: 'Logistik',
      },
    ],
  },
];

export const mockMainMenu = [
  {
    url: '/de-de/geiger-gruppe/familie-vision-werte/',
    label: 'Geiger Gruppe',
  },
  {
    url: '/de-de/karriere/geiger-als-arbeitgeber/',
    label: 'Karriere',
  },
  {
    url: '/de-de/neuigkeiten/',
    label: 'Neuigkeiten',
  },
  {
    url: '/de-de/referenzen/',
    label: 'Referenzen',
  },
];

export const mockContactLink = {
  id: 'f6d02ae7-a08e-44ee-8651-baf9b81c4b56',
  url: '',
  linktype: 'story',
  fieldtype: 'multilink',
  cached_url: 'de-de/kontakt/',
  story: {
    name: 'Kontakt',
    id: 181238437,
    uuid: 'f6d02ae7-a08e-44ee-8651-baf9b81c4b56',
    slug: 'kontakt',
    url: 'kontakt/',
    full_slug: 'de-de/kontakt',
    _stopResolving: true,
    content: {},
    created_at: '',
    published_at: '',
  },
} as StoryblokMultilink;

export const mockTeaserLink = {
  id: 'f55d9064-2fe1-40a3-8cbb-ab440b94a50e',
  url: '',
  linktype: 'story',
  fieldtype: 'multilink',
  cached_url: 'de-de/geiger-gruppe/kreislaufgesellschaft/',
  story: {
    name: 'Kreislaufgesellschaft',
    id: 308665498,
    uuid: 'f55d9064-2fe1-40a3-8cbb-ab440b94a50e',
    slug: 'kreislaufgesellschaft',
    url: 'kreislaufgesellschaft/',
    full_slug: 'de-de/geiger-gruppe/kreislaufgesellschaft',
    _stopResolving: true,
    content: {},
    created_at: '',
    published_at: '',
  },
} as StoryblokMultilink;
export default { mockServiceMenu, mockMainMenu, mockContactLink, mockTeaserLink };
